import type { ReactNode } from 'react'
import { cn } from '@/internationalization/cn'

export interface PageHeaderProps {
  title: ReactNode
  description?: ReactNode
  /** Primary + secondary actions. Stack full-width below sm. */
  actions?: ReactNode
  /** Breadcrumbs or a back link, rendered above the title. */
  eyebrow?: ReactNode
  /** Tabs or a filter bar, rendered below and flush with the page content. */
  below?: ReactNode
  className?: string
}

/**
 * Every routed screen opens with this. Consistent title size and action
 * placement is most of what makes a multi-screen app feel like one app.
 */
export function PageHeader({ title, description, actions, eyebrow, below, className }: PageHeaderProps) {
  return (
    <header className={cn('mb-5', className)}>
      {eyebrow && <div className="mb-2">{eyebrow}</div>}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h1 className="truncate text-xl font-semibold tracking-tight text-fg sm:text-2xl">{title}</h1>
          {description && <p className="mt-1 max-w-2xl text-base text-fg-muted">{description}</p>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </div>
      {below && <div className="mt-4">{below}</div>}
    </header>
  )
}
